export default __webpack_public_path__ + "static/home_hero_small-32ed5d0580f79bf67beb48ffdbd460a5.png";